import { observable, makeObservable } from 'mobx';

export default class Product {
  id;
  checked = false;
  title;
  image;
  link;
  rating;
  ratingCount;
  description;
  callToActions;
  ratingAndReviewId;
  productCategoryType;
  variantsgtin;
  /**
   * param {id} mapped to GTIN
   */

  constructor(
    id,
    title,
    image,
    link,
    rating,
    description,
    rating_count,
    checked,
    rating_review_id = null,
    productCategoryType = null,
    variantsgtin
  ) {
    makeObservable(this, {
      id: observable,
      checked: observable,
      title: observable,
      image: observable,
      link: observable,
      rating: observable,
      ratingCount: observable,
      description: observable,
      callToActions: observable,
      ratingAndReviewId: observable,
      productCategoryType: observable,
      variantsgtin: observable
    });

    this.id = id;
    this.title = title;
    this.image = image;
    this.link = link;
    this.rating = rating;
    this.description = description;
    this.ratingCount = rating_count;
    this.callToActions = null;
    this.ratingAndReviewId = rating_review_id;
    this.checked = checked ? true : false;
    this.productCategoryType = productCategoryType;
    this.variantsgtin = variantsgtin;
  }
}
